import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload, doPostFiles, doPutFiles } from './utils'

export const getManageLawProjectTracking = (request) => {
  const url = `${API_ROOT}/progress/admin/law/project/tracking/search`
  return doPost(url, request)
}

export const getManageProjectTracking = (projectId) => {
  const url = `${API_ROOT}/progress/admin/law/project/${projectId}/form`
  return doGet(url)
}

export const saveTrackingNote = (projectId, request) => {
  const url = `${API_ROOT}/progress/admin/law/project/${projectId}/form`
  return doPostFiles(url, request)
}

export const getTrackingNote = (projectVersionId) => {
  const url = `${API_ROOT}/progress/admin/law/project/${projectVersionId}/form`
  return doGet(url)
}

export const editTrackingNote = (projectVersionId, lawTrackingId, request) => {
  const url = `${API_ROOT}/progress/admin/law/project/${projectVersionId}/form/${lawTrackingId}`
  return doPutFiles(url, request)
}

export const deleteTrackingNote = (projectVersionId, projectDelayId) => {
  const url = `${API_ROOT}/progress/admin/law/project/${projectVersionId}/form/${projectDelayId}`
  return doDelete(url)
}

export const getDownload = (id, fileId) => {
  const url = `${API_ROOT}/progress/admin/law/project/${id}/attachments/${fileId}/download`
  return doDownload(url)
}

export const deleteAttachments = (id, lawTrackingId) => {
  const url = `${API_ROOT}/progress/admin/law/project/${id}/attachments/${lawTrackingId}`
  return doDelete(url)
}
